import React from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import AgencySignup from './agencySignup';
import MainSignup from './mainSignup';



export const AGENCY_PLAN_IDS = {
  AGENCY_MONTHLY: {
    id: "Agency-Bundle-USD-Monthly",
    attendees: 1000,
    price: 349,
  },
  CREATOR_YEARLY: {
    id: "Creators-Pro-USD-Yearly",
    attendees: 500,
    price: 990,
  },
} as const;

export interface AgencyPlanPricing {
  planId: string;
  planName: string;
  period: "monthly" | "yearly";
  price: number;
  attendees: number;
}



const Signup = () => {
  const [searchParams] = useSearchParams();
  const planId = searchParams.get("planId") ?? "";
  const isAgency = planId?.includes(AGENCY_PLAN_IDS.AGENCY_MONTHLY.id) || planId?.includes(AGENCY_PLAN_IDS.CREATOR_YEARLY.id);
  debugger;
    return (
      isAgency ? <AgencySignup planIds={Object.values(AGENCY_PLAN_IDS).map(plan => plan.id)} isYearly={planId?.includes("Yearly")}  /> : <MainSignup />
    )
}

export default Signup